import { ChangeEvent, useEffect, useId, useState } from "react"
import "../style.css"
import { UploadAndDisplayImageProps } from "./model"

export const UploadAndDisplayImage = (props: UploadAndDisplayImageProps) => {
    const [selectedImage, setSelectedImage] = useState<File | null>(null)
    const [previewUrl, setPreviewUrl] = useState<string | null>(null)
    const inputId = useId()

    useEffect(() => {
        if (props.alreadySelectedFile) {
            setSelectedImage(props.alreadySelectedFile)
        } else {
            setSelectedImage(null)
        }
    }, [props.alreadySelectedFile])

    useEffect(() => {
        if (!selectedImage) {
            setPreviewUrl(null)
            return
        }

        const objectUrl = URL.createObjectURL(selectedImage)
        setPreviewUrl(objectUrl)

        return () => {
            URL.revokeObjectURL(objectUrl)
        }
    }, [selectedImage])

    const handleSelectImage = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files

        if (files && files.length > 0) {
            setSelectedImage(files[0])
            props.onImageSelected(files[0])
        }
    }

    const handleDivContainerClicked = () => {
        const inputElement = document.getElementById(inputId) as HTMLInputElement | null

        if (!inputElement) return

        if (!selectedImage) {
            inputElement.click()
        } else {
            inputElement.value = ""
        }
    }

    const handleRemoveImage = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()

        if (selectedImage) {
            props.onImageRemoved(selectedImage)
            setSelectedImage(null)
        }

        const inputElement = document.getElementById(inputId) as HTMLInputElement | null
        if (inputElement) {
            inputElement.value = ""
        }
    }

    return (
        <div
            className="img-zone-container relative w-full cursor-pointer"
            onClick={handleDivContainerClicked}
        >
            <input
                type="file"
                id={inputId}
                className="file-upload hidden"
                accept=".jpg,.jpeg,.png,.gif"
                onChange={handleSelectImage}
            />

            {selectedImage && previewUrl ? (
                <div
                    className="img-selected-container flex aspect-square w-full max-w-[160px] items-center justify-center overflow-hidden rounded-[12px] bg-white"
                    style={{
                        backgroundImage: `url(${previewUrl})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center center",
                        backgroundSize: "cover",
                    }}
                >
                    <button
                        type="button"
                        className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-figmaGray"
                        onClick={handleRemoveImage}
                        aria-label="Șterge imaginea"
                    >
                        <img src="/images/denied-icon.svg" alt="Șterge" />
                    </button>
                </div>
            ) : (
                <div className="flex aspect-square w-full max-w-[160px] items-center justify-center rounded-[12px] bg-white">
                    <div className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-figmaGray">
                        <img src="/images/upload-icon.svg" alt="Încarcă" />
                    </div>
                </div>
            )}
        </div>
    )
}